import {pushGTMEvent} from '../init'

/**
 * @name analyticsLogEvent
 *
 * @description
 * Logs an analytics event.
 *
 * @param {string | null} name - The name of the event to log.
 * @param {Object} params - The parameters of the event.
 */
function analyticsLogEvent(name: string | null, params: object) {
    if (!name) {
        return
    }

    pushGTMEvent({event: name, ...params})
}

export {analyticsLogEvent}
